import CalculationStatus from "../../../../types/CalculationStatus";
import styles from "./constructionCalculationsNewPanelCalculationItem.module.scss";

const useConstructionCalculationsNewPanelCalculationItem = (
  status: CalculationStatus,
): {
  className: string;
  iconName: string;
} => {
  if (
    status === CalculationStatus.Failed ||
    status === CalculationStatus.NoValidProfilesFound
  ) {
    return {
      iconName: "ErrorBadge",
      className: styles.calculationStatusFailed,
    };
  }

  if (
    status === CalculationStatus.Pending ||
    status === CalculationStatus.Created
  ) {
    return {
      iconName: "Info",
      className: styles.calculationStatus,
    };
  }

  if (
    status === CalculationStatus.Completed ||
    status === CalculationStatus.ValidProfilesFound
  ) {
    return {
      iconName: "Completed",
      className: styles.calculationStatusCompleted,
    };
  }

  return {
    iconName: "Info",
    className: styles.calculationStatusPartially,
  };
};

export default useConstructionCalculationsNewPanelCalculationItem;
